import React from "react";
import { BankInput } from "../../../components/user/AutoSuggestion.jsx";

export default function Bank({
  currentUser,
  handleChange,
  handleStateChange,
  bankUpdate,
}) {
  const currencyOptions = [
    { value: "EUR", label: "Euro €" },
    { value: "USD", label: "USD $" },
    { value: "CNY", label: "CNY ¥" },
    { value: "GBP", label: "GBP £" },
    { value: "AUD", label: "AUD $" },
    { value: "CAD", label: "CAD $" },
    { value: "HKD", label: "HKD $" },
    { value: "ILS", label: "ILS ₪" },
    { value: "JPY", label: "JPY ¥" },
    { value: "KRW", label: "KRW ₩" },
    { value: "CHF", label: "CHF" },
    { value: "MXN", label: "MXN $" },
    { value: "QAR", label: "QAR ﷼" },
    { value: "RUB", label: "RUB руб" },
    { value: "SAR", label: "SAR ﷼" },
    { value: "INR", label: "INR ₹" },
    { value: "TRY", label: "TRY ₺" },
    { value: "VND", label: "VND ₫" },
    { value: "BRL", label: "BRL R$" },
    { value: "AZR", label: "AZR R" },
    { value: "SGD", label: "SGD $" }
  ];
  return (
    <div className="membership">
      <div className="bank">
        <div className="form-group row">
          <label className="field col-form-label" htmlFor="IBAN">
            IBAN
          </label>
          <div className="col">
            <input
              type="text"
              className="form-control"
              //name="IBAN"
              id="IBAN"
              value={
                currentUser?.bankInfo?.IBAN ? currentUser.bankInfo.IBAN : ""
              }
              name="currentUser.bankInfo.IBAN"
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="form-group row">
          <label className="field col-form-label" htmlFor="bank">
            Bank
          </label>
          <div className="col drop">
            <BankInput
              changeHandler={(bank) =>
                handleStateChange("currentUser.bankInfo.bank", bank)
              }
              valueItem={currentUser?.bankInfo?.bank}
            />
          </div>
        </div>
        <div className="form-group row">
          <label className="field col-form-label" htmlFor="branchOfBank">
            Branch of Bank
          </label>
          <div className="col">
            <input
              type="text"
              className="form-control"
              //name="branchOfBank"
              id="branchOfBank"
              value={
                currentUser?.bankInfo?.branchOfBank
                  ? currentUser.bankInfo.branchOfBank
                  : ""
              }
              name="currentUser.bankInfo.branchOfBank"
              onChange={handleChange}
            />
          </div>
        </div>
      </div>
      <div className="bank_">
        <div className="form-group row">
          <label className="field col-form-label" htmlFor="currency">
            Currency
          </label>
          <div className="col">
            <select
              className="form-control _fix"
              value={currentUser?.currency || ""}
              onChange={(e) => handleStateChange("currentUser.currency", e.target.value)}
            >
              {currencyOptions.map((currency) => (
                <option key={currency.value} value={currency.value}>
                  {currency.label}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>

      <table className="table table-profile">
        <tbody>
          <tr className="highlight">
            <td className="field">&nbsp;</td>
            <td className="p-t-10 p-b-10">
              <button onClick={bankUpdate} className="btn btn-primary width-65">
                Update
              </button>
              <button
                type="submit"
                className="btn btn-red btn-red-without-border width-65 m-l-5"
              >
                Cancel
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}
